export interface IDealerServiceHours {
  days: number[],
  open: string,
  close: string
}
